var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 5.71927L10.3401 7.80927C9.92009 9.61427 9.09009 10.3443 7.53009 10.1943C7.28009 10.1743 7.01009 10.1293 6.72009 10.0593L5.88009 9.85927C3.79509 9.36427 3.15009 8.33427 3.64009 6.24427L4.13009 4.14927C4.23009 3.72427 4.35009 3.35427 4.50009 3.04927C5.08509 1.83927 6.08009 1.51427 7.75009 1.90927L8.58509 2.10427C10.6801 2.59427 11.3201 3.62927 10.8301 5.71927Z",
    fill: "white",
    stroke: "#6941C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53017 10.1958C7.22017 10.4058 6.83017 10.5808 6.35517 10.7358L5.56517 10.9958C3.58017 11.6358 2.53517 11.1008 1.89017 9.11578L1.25017 7.14078C0.610171 5.15578 1.14017 4.10578 3.12517 3.46578L3.91517 3.20578C4.12017 3.14078 4.31517 3.08578 4.50017 3.05078C4.35017 3.35578 4.23017 3.72578 4.13017 4.15078L3.64017 6.24578C3.15017 8.33578 3.79517 9.36578 5.88017 9.86078L6.72017 10.0608C7.01017 10.1308 7.28017 10.1758 7.53017 10.1958Z",
    fill: "white",
    stroke: "#6941C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32031 4.76562L8.74531 5.38063",
    stroke: "#6941C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83008 6.69922L7.28008 7.06922",
    stroke: "#6941C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNotes);
export default __webpack_public_path__ + "static/media/tableNotes.849a32d4975c70e3fe3d083ef1cc564c.svg";
export { ForwardRef as ReactComponent };